<template>
  <div class="col-12 full-width">
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="TX"
        name="tx_nivel_sinal"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        name="tx_nivel_sinal"
        v-model="itemOsContract.tx_nivel_sinal"
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="RX"
        name="rx_nivel_sinal"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        name="rx_nivel_sinal"
        v-model="itemOsContract.rx_nivel_sinal"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Valor da NAP"
        name="valor_tap_nap"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        fill-input
        name="valor_tap_nap"
        input-debounce="0"
        placeholder="Digite aqui"
        v-model="itemOsContract.valor_tap_nap"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <NapForm
      :typeOs="typeOs"
      :itemOsContract="itemOsContract"
    />
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Potência Ótica"
        name="potencia_otica"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        v-model="itemOsContract.potencia_otica"
        name="potencia_otica"
        color="red-9"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
  </div>
</template>

<script>
  import { inject, onBeforeMount } from "vue";
import RequiredLabel from "../RequiredLabel.vue";
import NapForm from "./NapForm.vue";

  export default {
    name: "BackboneGpenForm",
    components: {
      NapForm,
      RequiredLabel,
    },
    props: {
      itemOsContract: Object,
      typeOs: Number,
    },

    setup(props, { emit }) {
      let requestData = {
        tx_nivel_sinal: "",
        rx_nivel_sinal: "",
        valor_tap_nap: "",
        potencia_otica: "",
        endereco_nap: "",
        nome_nap: "",
        casas_conectadas_nap: "",
      };

      const addFieldsToRequestData = inject("addFieldsToRequestData");

      onBeforeMount(() => {
        addFieldsToRequestData(requestData);
      });

      return {
        requestData,
      };
    },
  };
</script>

<style scoped lang="scss">
  label {
    font-family: Roboto;
    font-style: normal;
  }
  .group-input {
    label {
      font-weight: bold;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.4);
    }
  }
</style>
